import React from 'react';

import VerifyEmailForm from '@components/forms/verifyEmail';

import useVerifyEmail from './hooks';

function VerifyEmail({ onSuccess, onDecline }: { onSuccess?: () => void; onDecline?: () => void }) {
	const { initialValues, onSubmit } = useVerifyEmail({ onSuccess });

	return <VerifyEmailForm initialValues={initialValues} onDecline={onDecline} onSubmit={onSubmit} />;
}

export default VerifyEmail;
